import { RootState } from '@/shared/store'
import { depotsAdapter } from './depotsAdapters'

export const depotsSelectors = depotsAdapter.getSelectors<RootState>(
  (state) => state.depots,
)
